<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div
          class="add-item d-flex justify-content-between"
          style="width: -webkit-fill-available"
        >
          <div class="page-title">
            <h4>Gestion de l'Entreprise</h4>
            <h6>Details de l'Entreprise</h6>
          </div>
          <!-- Edit/Cancel Edit Button -->
          <div class="edit-actions">
            <router-link
              v-if="canEditCompany"
              to="/societe/page"
              class="btn btn-outline-primary me-2"
            >
              <vue-feather type="file-text" class="me-2"></vue-feather>
              Mise en page
            </router-link>
            <button
              v-if="canEditCompany && !isEditMode"
              type="button"
              class="btn btn-primary"
              @click="enableEditMode"
            >
              <vue-feather type="edit" class="me-2"></vue-feather>
              Modifier
            </button>
            <button
              v-else
              type="button"
              class="btn btn-secondary"
              @click="cancelEdit"
            >
              <vue-feather type="x" class="me-2"></vue-feather>
              Annuler la modification
            </button>
          </div>
        </div>
      </div>

      <!-- Error Display -->
      <div
        v-if="errors && Object.keys(errors).length > 0"
        class="alert alert-danger"
      >
        <h6>Erreurs de validation :</h6>
        <ul class="mb-0">
          <li v-for="(errorArray, field) in errors" :key="field">
            <strong>{{ getFieldLabel(field) }} :</strong>
            <span v-for="(error, index) in errorArray" :key="index">{{
              error
            }}</span>
          </li>
        </ul>
      </div>

      <!-- /add -->
      <form @submit.prevent="submitForm">
        <div class="card">
          <div class="card-body add-product pb-0">
            <div class="accordion-card-one accordion" id="accordionExample">
              <div class="accordion-item">
                <div class="accordion-header" id="headingOne">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-controls="collapseOne"
                  >
                    <div class="addproduct-icon">
                      <h5>
                        <vue-feather type="info" class="add-info"></vue-feather
                        ><span>Informations Générales</span>
                      </h5>
                      <a href="javascript:void(0);"
                        ><vue-feather
                          type="chevron-down"
                          class="chevron-down-add"
                        ></vue-feather
                      ></a>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Raison Sociale *</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.societe_nom }"
                            v-model="form.societe_nom"
                            maxlength="50"
                            required
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Email *</label>
                          <input
                            type="email"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.email }"
                            v-model="form.email"
                            maxlength="50"
                            required
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Adresse *</label>
                          <textarea
                            class="form-control"
                            :class="{ 'is-invalid': errors?.adress }"
                            v-model="form.adress"
                            rows="3"
                            maxlength="200"
                            required
                            :readonly="!isEditMode"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Code Postal *</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.code_postal }"
                            v-model="form.code_postal"
                            maxlength="50"
                            required
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Téléphone *</label>
                          <input
                            type="tel"
                            class="form-control"
                            :class="{
                              'is-invalid': errors?.telephone_personnel,
                            }"
                            v-model="form.telephone_personnel"
                            maxlength="50"
                            required
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">CIN *</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.cin }"
                            v-model="form.cin"
                            maxlength="50"
                            required
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Nom Complet Français</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{
                              'is-invalid': errors?.nom_complet_francais,
                            }"
                            v-model="form.nom_complet_francais"
                            maxlength="50"
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label"
                            >الاسم الكامل بالعربية</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.nom_complet_arabe }"
                            v-model="form.nom_complet_arabe"
                            maxlength="50"
                            dir="rtl"
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label"
                            >Lieu de Naissance (Code)</label
                          >
                          <input
                            type="number"
                            min="0"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.lieu_naissance }"
                            v-model.number="form.lieu_naissance"
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                  <div class="col-lg-6 col-sm-6 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">URL Site Web</label>
                      <input
                        type="url"
                        class="form-control"
                        :class="{ 'is-invalid': errors?.url }"
                        v-model="form.url"
                        maxlength="50"
                        placeholder="https://exemple.com"
                        :readonly="!isEditMode"
                        @blur="normalizeUrl"
                      />
                    </div>
                  </div>
                    </div>
                    <!-- /Editor -->
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-card-one accordion" id="accordionExample2">
              <div class="accordion-item">
                <div class="accordion-header" id="headingTwo">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-controls="collapseTwo"
                  >
                    <div class="text-editor add-list">
                      <div class="addproduct-icon list icon">
                        <h5>
                          <vue-feather
                            type="life-buoy"
                            class="add-info"
                          ></vue-feather
                          ><span>Informations Fiscales</span>
                        </h5>
                        <a href="javascript:void(0);"
                          ><vue-feather
                            type="chevron-down"
                            class="chevron-down-add"
                          ></vue-feather
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample2"
                >
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">RC</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors?.rc }"
                          v-model="form.rc"
                          maxlength="50"
                          :readonly="!isEditMode"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">IF</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors?.identifiant_fiscal }"
                          v-model="form.identifiant_fiscal"
                          maxlength="50"
                          :readonly="!isEditMode"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">TP</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors?.tp }"
                          v-model="form.tp"
                          maxlength="50"
                          :readonly="!isEditMode"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">ICE</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors?.ice }"
                          v-model="form.ice"
                          maxlength="50"
                          :readonly="!isEditMode"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">CNSS</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors?.cnss }"
                          v-model="form.cnss"
                          maxlength="50"
                          :readonly="!isEditMode"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-card-one accordion" id="accordionExample4">
              <div class="accordion-item">
                <div class="accordion-header" id="headingFive">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-controls="collapseFour"
                  >
                    <div class="text-editor add-list">
                      <div class="addproduct-icon list">
                        <h5>
                          <vue-feather
                            type="list"
                            class="add-info"
                          ></vue-feather
                          ><span> Informations Bancaires </span>
                        </h5>
                        <a href="javascript:void(0);"
                          ><vue-feather
                            type="chevron-down"
                            class="chevron-down-add"
                          ></vue-feather
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample4"
                >
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Banque</label>
                          <vue-select
                            :options="moroccanBanks"
                            placeholder="Rechercher et sélectionner une banque"
                            :class="{ 'is-invalid': errors?.nom_banque }"
                            v-model="form.nom_banque"
                            :disabled="!isEditMode"
                            :clearable="true"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">RIB</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.rib }"
                            v-model="form.rib"
                            maxlength="50"
                            placeholder="FR76 1234 5678 9012 3456 78"
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">SWIFT</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.code_banque_swift }"
                            v-model="form.code_banque_swift"
                            maxlength="50"
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Capital</label>
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors?.capital }"
                            v-model="form.capital"
                            maxlength="50"
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-card-one accordion" id="accordionExample5">
              <div class="accordion-item">
                <div class="accordion-header" id="headingFour">
                  <div
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-controls="collapseFive"
                  >
                    <div class="text-editor add-list">
                      <div class="addproduct-icon list">
                        <h5>
                          <vue-feather
                            type="list"
                            class="add-info"
                          ></vue-feather
                          ><span> Informations Sociales </span>
                        </h5>
                        <a href="javascript:void(0);"
                          ><vue-feather
                            type="chevron-down"
                            class="chevron-down-add"
                          ></vue-feather
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample5"
                >
                  <div class="accordion-body">
                    <div class="row">
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label"
                            >Adresse Sociale (Français)</label
                          >
                          <textarea
                            class="form-control"
                            :class="{
                              'is-invalid':
                                errors?.adresse_siege_social_francais,
                            }"
                            v-model="form.adresse_siege_social_francais"
                            rows="3"
                            maxlength="200"
                            :readonly="!isEditMode"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-lg-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label"
                            >العنوان الاجتماعي (العربية)</label
                          >
                          <textarea
                            class="form-control"
                            :class="{
                              'is-invalid': errors?.adresse_siege_social_arabe,
                            }"
                            v-model="form.adresse_siege_social_arabe"
                            rows="3"
                            maxlength="200"
                            dir="rtl"
                            :readonly="!isEditMode"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <label class="form-label">Téléphone Entreprise</label>
                          <input
                            type="tel"
                            class="form-control"
                            :class="{
                              'is-invalid': errors?.telephone_entreprise,
                            }"
                            v-model="form.telephone_entreprise"
                            maxlength="50"
                            :readonly="!isEditMode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="accordion-card-one accordion"
                    id="accordionExample3"
                  >
                    <div class="accordion-item">
                      <div class="accordion-header" id="headingThree">
                        <div
                          class="accordion-button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-controls="collapseThree"
                        >
                          <div class="addproduct-icon list">
                            <h5>
                              <vue-feather
                                type="image"
                                class="add-info"
                              ></vue-feather
                              ><span>Téléchargement du logo </span>
                            </h5>
                            <a href="javascript:void(0);"
                              ><vue-feather
                                type="chevron-down"
                                class="chevron-down-add"
                              ></vue-feather
                            ></a>
                          </div>
                        </div>
                      </div>
                      <div
                        id="collapseThree"
                        class="accordion-collapse collapse show"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample3"
                      >
                        <div class="accordion-body">
                          <div class="text-editor add-list add mb-3">
                            <div class="row">
                              <div class="col-lg-6">
                                <label class="form-label"
                                  >Téléchargement du logo (petit)
                                </label>
                                <div class="add-choosen">
                                  <div v-if="isEditMode">
                                    <div class="image-upload">
                                      <input
                                        type="file"
                                        @change="handleImageUpload1"
                                        accept="image/jpeg,image/png,image/gif,image/svg+xml"
                                      />
                                      <div class="image-uploads m-0">
                                        <i
                                          data-feather="plus-circle"
                                          class="plus-down-add me-0"
                                        ></i>
                                        <h4>Ajouter Logo Petit</h4>
                                        <p class="text-muted small">
                                          Max 2MB - JPEG, PNG, GIF, SVG
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="phone-img" v-if="isVisible1">
                                    <img
                                      v-if="imagePreview1"
                                      :src="imagePreview1"
                                      alt="Preview"
                                      style="
                                        max-width: 100%;
                                        max-height: 10rem;
                                        object-fit: contain;
                                        display: block;
                                      "
                                    />
                                    <button
                                      v-if="isEditMode"
                                      type="button"
                                      @click="hideProduct1"
                                      class="btn btn-danger btn-sm mt-2"
                                    >
                                      Supprimer
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <label class="form-label"
                                  >Téléchargement du logo
                                </label>
                                <div class="add-choosen">
                                  <div v-if="isEditMode">
                                    <div class="image-upload">
                                      <input
                                        type="file"
                                        @change="handleImageUpload"
                                        accept="image/jpeg,image/png,image/gif,image/svg+xml"
                                      />
                                      <div class="image-uploads">
                                        <i
                                          data-feather="plus-circle"
                                          class="plus-down-add me-0"
                                        ></i>
                                        <h4>Ajouter Logo Principal</h4>
                                        <p class="text-muted small">
                                          Max 2MB - JPEG, PNG, GIF, SVG
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="phone-img" v-if="isVisible">
                                    <img
                                      v-if="imagePreview"
                                      :src="imagePreview"
                                      alt="Preview"
                                      style="
                                        max-width: 100%;
                                        max-height: 10rem;
                                        object-fit: contain;
                                        display: block;
                                      "
                                    />
                                    <button
                                      v-if="isEditMode"
                                      type="button"
                                      @click="hideProduct"
                                      class="btn btn-danger btn-sm mt-2"
                                    >
                                      Supprimer
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Action Buttons - Only show when in edit mode -->
        <div class="col-lg-12" v-if="isEditMode">
          <div class="btn-addproduct mb-4">
            <button
              type="button"
              class="btn btn-cancel me-2"
              @click="cancelEdit"
            >
              Annuler
            </button>
            <button type="submit" class="btn btn-submit" :disabled="isLoading">
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              {{ isLoading ? "Modification..." : "Modifier" }}
            </button>
          </div>
        </div>
      </form>
      <!-- /add -->
    </div>
  </div>
  <add-product-modal></add-product-modal>
</template>

<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
import Swal from "sweetalert2";
import { toast } from "vue3-toastify";
import { getCompanyData, updateCompany } from "@/services/companyService";
import { getCurrentUser } from "@/services/authService";
import moroccanBanks from "@/assets/json/moroccan-banks.json";

const imagePreview = ref(null);
const imagePreview1 = ref(null);
const APP_URL = (process.env.VUE_APP_URL || "").replace(/\/$/, "");

export default {
  components: {},
  computed: {
    canEditCompany() {
      const role = String(getCurrentUser()?.role || "").toLowerCase();
      return role === "admin" || role === "dev";
    },
  },
  data() {
    return {
      isEditMode: false, // Add edit mode state
      moroccanBanks,
      originalFormData: null, // Store original data for cancellation
      form: {
        societe_nom: "",
        adress: "",
        code_postal: "",
        telephone_personnel: "",
        email: "",
        cin: "",
        rc: "",
        ice: "",
        tp: "",
        cnss: "",
        identifiant_fiscal: "",
        lieu_naissance: null,
        nom_complet_arabe: "",
        nom_complet_francais: "",
        nom_banque: "",
        code_banque_swift: "",
        adresse_siege_social_francais: "",
        adresse_siege_social_arabe: "",
        telephone_entreprise: "",
        rib: "",
        url: "",
        capital: "",
        logo: "",
        logo_small: "",
        created_at: "",
      },
      isVisible: false,
      isVisible1: false,
      errors: {},
      isLoading: false,
      startdate: currentDate,
      startdateOne: currentDateOne,
      dateFormat: "dd-MM-yyyy",
      imagePreview,
      imagePreview1,
      selectedImage: null,
      selectedImage1: null,
      fieldLabels: {
        societe_nom: "Raison Sociale",
        adress: "Adress",
        code_postal: "Code Postal",
        telephone_personnel: "Téléphone Personnel",
        email: "Email",
        cin: "CIN",
        rc: "RC",
        ice: "ICE",
        tp: "TP",
        cnss: "CNSS",
        identifiant_fiscal: "Identifiant Fiscal",
        lieu_naissance: "Lieu de Naissance",
        nom_complet_arabe: "Nom Complet Arabe",
        nom_complet_francais: "Nom Complet Français",
        nom_banque: "Nom Banque",
        code_banque_swift: "Code SWIFT",
        adresse_siege_social_francais: "Adresse Siège Social Français",
        adresse_siege_social_arabe: "Adresse Siège Social Arabe",
        telephone_entreprise: "Téléphone Entreprise",
        rib: "RIB",
        url: "URL",
        capital: "Capital",
        logo: "Logo",
        logo_small: "Logo Small",
      },
    };
  },
  methods: {
    normalizeUrl() {
      if (this.form.url && !/^https?:\/\//i.test(this.form.url)) {
        this.form.url = `https://${this.form.url}`;
      }
    },
    // Enable edit mode
    enableEditMode() {
      if (!this.canEditCompany) return;
      this.isEditMode = true;
      // Store original data for potential cancellation
      this.originalFormData = JSON.parse(JSON.stringify(this.form));
      this.errors = {}; // Clear any existing errors
    },

    // Cancel edit mode and restore original data
    cancelEdit() {
      Swal.fire({
        title: "Annuler les modifications ?",
        text: "Tous les changements non sauvegardés seront perdus.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, annuler",
        cancelButtonText: "Continuer la modification",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isEditMode = false;
          this.errors = {};

          // Restore original form data
          if (this.originalFormData) {
            this.form = JSON.parse(JSON.stringify(this.originalFormData));
          }

          // Reset image selections
          this.selectedImage = null;
          this.selectedImage1 = null;

          // Reload company data to ensure consistency
          this.getCompanyData();
        }
      });
    },

    getFieldLabel(field) {
      return this.fieldLabels[field] || field;
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file size (2MB)
        if (file.size > 2 * 1024 * 1024) {
          toast.error("Le fichier dépasse la taille maximale de 2MB");
          return;
        }
        // Validate file type
        const allowedTypes = [
          "image/jpeg",
          "image/png",
          "image/gif",
          "image/svg+xml",
        ];
        if (!allowedTypes.includes(file.type)) {
          toast.error(
            "Type de fichier non autorisé. Utilisez JPEG, PNG, GIF ou SVG"
          );
          return;
        }
        this.selectedImage = file;
        imagePreview.value = URL.createObjectURL(file);
        this.isVisible = true;
      }
    },

    handleImageUpload1(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file size (2MB)
        if (file.size > 2 * 1024 * 1024) {
          toast.error("Le fichier dépasse la taille maximale de 2MB");
          return;
        }
        // Validate file type
        const allowedTypes = [
          "image/jpeg",
          "image/png",
          "image/gif",
          "image/svg+xml",
        ];
        if (!allowedTypes.includes(file.type)) {
          toast.error(
            "Type de fichier non autorisé. Utilisez JPEG, PNG, GIF ou SVG"
          );
          return;
        }
        this.selectedImage1 = file;
        imagePreview1.value = URL.createObjectURL(file);
        this.isVisible1 = true;
      }
    },

    hideProduct() {
      this.isVisible = false;
      this.selectedImage = null;
      imagePreview.value = null;
    },

    hideProduct1() {
      this.isVisible1 = false;
      this.selectedImage1 = null;
      imagePreview1.value = null;
    },

    resetForm() {
      // Reset form to original state
      this.getCompanyData();
      this.errors = {};
      this.hideProduct();
      this.hideProduct1();
      this.isEditMode = false;
    },

    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },

    async getCompanyData() {
      try {
        this.isLoading = true;
        const response = await getCompanyData();
        if (response.success) {
          // Map all form fields from response data
          Object.keys(this.form).forEach((key) => {
            if (response.data[key] !== undefined) {
              this.form[key] = response.data[key] || "";
            }
          });

          // Normalize URL for display
          this.normalizeUrl();

          // Handle existing logos
          if (response.data.logo) {
            imagePreview.value = `${APP_URL}/storage/${response.data.logo}`;
            this.isVisible = true;
          }
          if (response.data.logo_small) {
            imagePreview1.value = `${APP_URL}/storage/${response.data.logo_small}`;
            this.isVisible1 = true;
          }
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
        toast.error(
          error.response?.data?.message ||
            "Erreur lors du chargement des données"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async submitForm() {
      if (!this.canEditCompany) {
        toast.error("Vous n’êtes pas autorisé à modifier l’entreprise.");
        return;
      }
      try {
        this.isLoading = true;
        this.errors = {};

        this.normalizeUrl();

        const formData = new FormData();

        // Add all form fields to FormData
        Object.keys(this.form).forEach((key) => {
          if (
            this.form[key] !== null &&
            this.form[key] !== "" &&
            key !== "logo" &&
            key !== "logo_small" &&
            key !== "created_at"
          ) {
            formData.append(key, this.form[key]);
          }
        });

        if (this.selectedImage) {
          formData.append("logo", this.selectedImage);
        }
        if (this.selectedImage1) {
          formData.append("logo_small", this.selectedImage1);
        }

        const response = await updateCompany(formData);

        if (response.success) {
          Swal.fire({
            icon: "success",
            title: "Succès",
            text: "Entreprise modifiée avec succès.",
            confirmButtonClass: "btn btn-success",
          });

          // Exit edit mode after successful update
          this.isEditMode = false;

          // Refresh data to get updated info
          await this.getCompanyData();
          window.dispatchEvent(new CustomEvent("company-branding-updated"));

          // Reset selected images
          this.selectedImage = null;
          this.selectedImage1 = null;
        }
      } catch (error) {
        console.error("Error updating company:", error);
        if (error.response?.status === 422) {
          // Laravel validation errorsv
          this.errors = error.response.data.errors || {};
          toast.error("Veuillez corriger les erreurs de validation");
          // Scroll to top to show errors
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          const message =
            error?.response?.data?.message || "Erreur lors de la mise à jour";
          toast.error(message);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },

  toggleCollapse() {
    const collapseHeader = this.$refs.collapseHeader;
    if (collapseHeader) {
      collapseHeader.classList.toggle("active");
      document.body.classList.toggle("header-collapse");
    }
  },

  async mounted() {
    await this.getCompanyData();
  },
};
</script>

<style scoped>
.is-invalid {
  border-color: #dc3545;
}

.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.text-muted {
  color: #6c757d !important;
}

.small {
  font-size: 0.875em;
}

input[dir="rtl"],
textarea[dir="rtl"] {
  text-align: right;
}

/* Custom file upload styling */
.image-upload input[type="file"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.image-uploads:hover {
  border-color: #007bff;
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
